import {Component, Inject, inject, ChangeDetectionStrategy} from "@angular/core"
import {FormsModule} from "@angular/forms"
import {MatButtonModule} from "@angular/material/button"
import {MatOptionModule} from "@angular/material/core"
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from "@angular/material/dialog"
import {MatInputModule} from "@angular/material/input"
import {MatSelectModule} from "@angular/material/select"
import {OrganizationGroupsTableItemFragment} from "@app/platform/components/organization-groups/organization-groups-table/organization-groups-table.generated"
import {OrganizationsService} from "@common/services/organizations/organizations.service"
import {OrganizationGroupDialogResult} from "@platform/components/organization-groups/organization-groups-table/organization-groups-table.component"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-edit-organization-group-dialog",
    templateUrl: "./edit-organization-group-dialog.component.html",
    imports: [MatInputModule, MatDialogModule, FormsModule, MatOptionModule, MatSelectModule, MatButtonModule],
})
export class EditOrganizationGroupDialogComponent {
    result: OrganizationGroupDialogResult

    readonly organizations = inject(OrganizationsService)

    constructor(
        public dialogRef: MatDialogRef<EditOrganizationGroupDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public organizationGroup: OrganizationGroupsTableItemFragment | null,
    ) {
        this.result = {
            id: organizationGroup?.id ?? null,
            name: organizationGroup?.name ?? "",
            organizationIds: organizationGroup?.organizations?.map((org) => org.id) ?? [],
        }
    }

    cancel(): void {
        this.dialogRef.close()
    }

    delete(): void {
        this.result.delete = true
        this.result.create = false
        this.dialogRef.close(this.result)
    }

    updateOrCreate(): void {
        this.result.delete = false
        this.result.create = this.result.id == null
        this.dialogRef.close(this.result)
    }
}
